import Axios from 'axios';
import Serve from '../app/serve';

async function listEmpresas() {  
  const app = Serve();
  let data;

  await Axios.get(app + 'listar_empresas ', {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    }
  })
    .then(res => {
      if (res?.data.status && (res.data.status === 498 || res.data.status === 401)) {
        localStorage.clear();
      } else {                       
        data = (res.data.dados_lojas);
      }
    })
  return data;
}

export default listEmpresas;